<template>
  <nav aria-label="Page navigation">
    <div class="pagination justify-content-center">
      <div
        class="page-item"
        :class="{
          disabled: (middleNumber > currentPage) || (totalPageNumber < displayPageNumber)
        }"
      >
        <span
          class="page-link"
          aria-label="Previous"
          @click="clickFirst"
        >
          <!-- <span aria-hidden="true">&laquo;</span> -->
          <font-awesome-icon icon="angle-double-left" />
        </span>
      </div>
      <div
        v-for="n in rangeNumbers"
        :key="n"
        class="page-item"
        :class="{
          active: currentPage === n
        }"
        @click="clickPageNumber(n)"
      >
        <span class="page-link">{{ n }}</span>
      </div>
      <div
        class="page-item"
        :class="{
          disabled: (middleNumber < currentPage) || (totalPageNumber < displayPageNumber)
        }"
      >
        <span
          class="page-link"
          aria-label="Next"
          @click="clickLast"
        >
          <!-- <span aria-hidden="true">&raquo;</span> -->
          <font-awesome-icon icon="angle-double-right" />
        </span>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: 'BootstrapPagination',
  props: {
    totalPageNumber: {
      type: Number,
      default: 5
    },
    displayPageNumber: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      currentPage: 1
    }
  },
  computed: {
    semiRangeNumber () {
      if (this.totalPageNumber < this.displayPageNumber) {
        return this.totalPageNumber / 2
      }
      return this.displayPageNumber / 2
    },
    minMiddleNumber () {
      return Math.ceil(this.semiRangeNumber)
    },
    maxMiddleNumber () {
      return Math.ceil(this.totalPageNumber - this.semiRangeNumber)
    },
    middleNumber () {
      if (this.currentPage < this.minMiddleNumber) {
        return this.minMiddleNumber
      } else if (this.currentPage > this.maxMiddleNumber) {
        return this.maxMiddleNumber
      }
      return this.currentPage
    },
    rangeNumbers () {
      let numbers = [this.middleNumber]
      for (let i = 0; i < Math.floor(this.semiRangeNumber); i++) {
        numbers.push(this.middleNumber + (i + 1))
        if (this.middleNumber - (i + 1) > 0) {
          numbers.push(this.middleNumber - (i + 1))
        }
      }
      return numbers.sort((a, b) => a - b)
    }
  },
  methods: {
    clickPageNumber (number) {
      this.$emit('number:updated', number)
      this.currentPage = number
    },
    clickFirst () {
      this.currentPage = 1
      this.clickPageNumber(1)
    },
    clickLast () {
      this.currentPage = this.totalPageNumber
      this.clickPageNumber(this.totalPageNumber)
    }
  }
}
</script>
